import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IShouldShowIdentityMigrationInfoToastParams {
}

export class ShouldShowIdentityMigrationInfoToastRequest extends Request<IShouldShowIdentityMigrationInfoToastParams, IResult> {
  constructor(params: IShouldShowIdentityMigrationInfoToastParams = {}) {
    super('shouldShowIdentityMigrationInfoToast', params);
  }
}
